import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "connection-ribbon" }
const _hoisted_2 = { class: "connection-ribbon__legend" }
const _hoisted_3 = { class: "connection-ribbon__legend-message" }

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectionRibbon',
  props: {
  type: { type: String as PropType<'exchange' | 'eotc'>, required: true },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n({ useScope: 'global' });

const message = computed(() => t(`modules.modals.unableToConnect.${props.type}.message`));
const actionText = computed(() => t('fundamentals.refresh'));

const action = () => window.location.reload();

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(message.value), 1),
      _createElementVNode("button", {
        class: "connection-ribbon__legend-button",
        onClick: action
      }, _toDisplayString(actionText.value), 1)
    ]),
    _createElementVNode("button", {
      class: "connection-ribbon__close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
    }, [
      _createVNode(_component_ot_icon, { name: "close" })
    ])
  ]))
}
}

})